import React, {useEffect, useMemo} from 'react';
import {Helmet} from "react-helmet";
import {
    Link, Navigate,
} from "react-router-dom";

import {connect} from 'react-redux';

import AnimatedPersona from "../components/persona/AnimatedPersona";
import UkLanding from "./uk/UkLanding";
import {useParams} from "react-router";
import SeoHeaders from "../components/SeoHeaders";


function Home({
}) {
    const {country} = useParams();
    const countryLink = country ? `/${country}/` : "/uk/"

    const countryName = useMemo(() => {
        switch (country){
            case 'mt':
                return "Malta";
            case 'uk':
                return "United Kingdom";
            case 'ie':
                return "Ireland";
            case 'default':
                return null;
        }
    }, [country]);

    if (country && !['ie','mt','uk'].includes(country)) {
        return <Navigate to="/not-found" replace={true} />
    }

  return (

    <React.Fragment>

        <SeoHeaders
            country={country}
            title={country ? "Buddy - [country]'s Leading Cloud Payroll Software" : "Buddy - Leading Cloud Payroll software in UK & Malta."}
            description={country ? "[country]'s easiest payroll software, learn how payroll can be easier. Free Demo Available." : "Cloud Payroll Software that empowers Payroll Service Providers to Collaborate with Employers and Employees."}
        />

        <div>
            {/** Add a hero block with title taking 1/4th of page */}
            {/*<div className="bg-buddy text-white py-10" style={{height: "25vh"}}>
                <h2 className="text-base font-semibold leading-7 text-indigo-400">Award winning support</h2>
                  <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">We’re here to help</p>
                  <p className="mt-6 text-base leading-7 text-gray-300">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Et, egestas tempus tellus etiam sed. Quam a
                    scelerisque amet ullamcorper eu enim et fermentum, augue. Aliquet amet volutpat quisque ut interdum
                    tincidunt duis.
                  </p>
            </div>*/}

            <div className="bg-white"  style={{height: "50vh"}}>
              <div className="px-6 py-24 sm:px-6 sm:py-24 lg:px-8">
                <div className="mx-auto max-w-2xl text-center">
                    <h1 className="text-employer-900 text-4xl tracking-tight leading-10 font-extrabold sm:leading-none sm:text-6xl">
                        <span>Making Payroll</span>
                        <br />
                        <span className="text-orange-400">About People</span>
                    </h1>
                  {/*<h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                    Making Payroll
                    <br />
                    About People
                  </h2>*/}
                  <p className="mx-auto mt-6 max-w-sm text-lg leading-8 text-employer-900">
                    You are important within the payroll process, help Buddy be a better payroll companion.
                  </p>
                  <div className="mt-10 flex items-center justify-center gap-x-6">
                    <span className="text-sm font-semibold leading-6 text-employer-900">
                        {
                            country ?
                                "Choose the profile which best describes you. " :
                                "Choose the country where you need Buddy's assistance. "
                        }<span aria-hidden="true">↓</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className={"bg-employer-900 bg-employee-900 bg-advisor-900 text-employer-300 text-employer-100 text-employer-600 text-employee-300 text-employee-100 text-employee-600 text-advisor-300 text-advisor-100 text-advisor-600"}></div>

            {/*
              Make a 3 column div 100% height of equal width and change to 3 columns of equal height when on mobile using tailwind
             */}
            <div className="flex flex-wrap">
                <AnimatedPersona
                    backgroundColorName={"employee"}
                    pretext={"I'm an"}
                    personaWords={['Employee', 'Worker']}
                    description={"I'm interested in being able to view and understand my payslips, apply for days off and see my leave balances."}
                    cta={"I'm an Employee"}
                    path={`${(!country ? countryLink : `` )}employee`}
                />
                <AnimatedPersona
                    backgroundColorName={"employer"}
                    pretext={"I am or represent an"}
                    personaWords={['Employer', 'In-House Payroll Expert', 'HR Manager']}
                    description={"I'm looking to manage holidays, track working hours, pay my team correctly and most importantly be compliant."}
                    cta={"I'm an Employer"}
                    path={`${(!country ? countryLink : `` )}employer`}
                />
                <AnimatedPersona
                    backgroundColorName={"advisor"}
                    pretext={"I am or represent a"}
                    personaWords={['Payroll Bureau','Accountant', 'Bookkeeper']}
                    description={"I want to help my clients issue payroll accurately and collaborate with me in doing their payroll."}
                    cta={"I'm a Payroll Bureau"}
                    path={`${(!country ? countryLink : `` )}payroll-bureau`}
                />
            </div>
        </div>
        <UkLanding/>

    </React.Fragment>
    
  );
}

const mapStateToProps = (state) => {

  // const {
  //   myAgreements,
  // } = state.my


  return {
    // showSidebar: state.sidebar.show,
    // loggedIn: state.my.profile ? true : false,
  }
}

const mapDispatchToProps = dispatch => ({
  // myGetAgreements: () => dispatch(MYACTIONS.myGetAgreements()),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home) 
